import FindVideoComponent from './FindVideo';

export default FindVideoComponent;
